var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArtRightImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 130,
    viewBox: "0 0 266 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.79 105.651L251.96 99.2306C253.19 97.1306 253.89 94.6906 253.89 92.0806C253.89 84.2406 247.53 77.8906 239.7 77.8906C231.87 77.8906 225.51 84.2506 225.51 92.0806C225.51 99.9106 231.87 106.271 239.7 106.271C243.31 106.271 246.61 104.921 249.12 102.691L254.79 105.651Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.13 83.0891C185.867 83.0891 193.76 75.1959 193.76 65.4591C193.76 55.7223 185.867 47.8291 176.13 47.8291C166.393 47.8291 158.5 55.7223 158.5 65.4591C158.5 75.1959 166.393 83.0891 176.13 83.0891Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.98 80.6291C185.716 80.6291 193.61 72.7359 193.61 62.9991C193.61 53.2624 185.716 45.3691 175.98 45.3691C166.243 45.3691 158.35 53.2624 158.35 62.9991C158.35 72.7359 166.243 80.6291 175.98 80.6291Z",
    fill: "#FFE8CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.16 69.4292C178.34 70.4892 184.19 66.3392 185.25 60.1592",
    stroke: "#FFA940",
    strokeWidth: 1.0949,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.569 61.9592C168.176 61.9592 168.669 61.4667 168.669 60.8592C168.669 60.2516 168.176 59.7592 167.569 59.7592C166.961 59.7592 166.469 60.2516 166.469 60.8592C166.469 61.4667 166.961 61.9592 167.569 61.9592Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.629 53.4992C179.237 53.4992 179.729 53.0067 179.729 52.3992C179.729 51.7917 179.237 51.2992 178.629 51.2992C178.022 51.2992 177.529 51.7917 177.529 52.3992C177.529 53.0067 178.022 53.4992 178.629 53.4992Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.551 24.0409C258.171 15.5909 251.841 8.25086 243.391 7.63086",
    stroke: "#FFA940",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.902 118.248L200.373 120.863L202.988 125.392L207.517 122.777L204.902 118.248Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 2.89223L204.029 1.09375L202.231 5.68407L206.821 7.48256L208.62 2.89223Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.38 6.17969L220.27 16.8697L230.079 12.4897L221.38 6.17969Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.171 118.781L227.911 110.051L223.48 119.841L234.171 118.781Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.941 94.7495C209.511 94.7495 209.081 94.5895 208.751 94.2595L205.671 91.1795C205.011 90.5195 205.011 89.4595 205.671 88.8095C206.331 88.1495 207.391 88.1495 208.041 88.8095L211.121 91.8895C211.781 92.5495 211.781 93.6095 211.121 94.2595C210.801 94.5795 210.371 94.7495 209.941 94.7495Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.18 49.6498C256.716 49.6498 257.96 48.4052 257.96 46.8698C257.96 45.3345 256.716 44.0898 255.18 44.0898C253.645 44.0898 252.4 45.3345 252.4 46.8698C252.4 48.4052 253.645 49.6498 255.18 49.6498Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.74 11.6606C121.574 11.6606 122.25 10.9846 122.25 10.1506C122.25 9.31667 121.574 8.64062 120.74 8.64062C119.907 8.64062 119.23 9.31667 119.23 10.1506C119.23 10.9846 119.907 11.6606 120.74 11.6606Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.92 61.7401C218.931 61.7401 219.75 60.9208 219.75 59.9101C219.75 58.8994 218.931 58.0801 217.92 58.0801C216.909 58.0801 216.09 58.8994 216.09 59.9101C216.09 60.9208 216.909 61.7401 217.92 61.7401Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.58 13.4491C181.591 13.4491 182.41 12.6297 182.41 11.6191C182.41 10.6084 181.591 9.78906 180.58 9.78906C179.569 9.78906 178.75 10.6084 178.75 11.6191C178.75 12.6297 179.569 13.4491 180.58 13.4491Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.56 16.8496L126.76 30.0096",
    stroke: "#FFA940",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.561 62.3691L240.211 66.1691",
    stroke: "#FFA940",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.579 110.98L164.189 99.0098",
    stroke: "#FFA940",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4995 93.5L0.189453 100.01",
    stroke: "#FFA940",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.789 34.5391C243.659 49.5991 235.419 65.7291 220.359 70.5991",
    stroke: "#FFA940",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.69 49.9003C212.434 49.9003 217.901 44.4337 217.901 37.6903C217.901 30.9469 212.434 25.4803 205.69 25.4803C198.947 25.4803 193.48 30.9469 193.48 37.6903C193.48 44.4337 198.947 49.9003 205.69 49.9003Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.86 48.2403C213.604 48.2403 219.07 42.7737 219.07 36.0303C219.07 29.2869 213.604 23.8203 206.86 23.8203C200.117 23.8203 194.65 29.2869 194.65 36.0303C194.65 42.7737 200.117 48.2403 206.86 48.2403Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.5 36.7603C213.15 40.7003 203.6 40.7903 203.6 40.7903C203.6 40.7903 200.56 32.0003 204.08 30.1203C208.34 27.8403 208.79 33.4403 208.79 33.4403C208.79 33.4403 213.91 32.2003 213.5 36.7603Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.24 31.3804C196.54 35.2104 197.45 40.4904 201.28 43.2004",
    stroke: "white",
    strokeWidth: 1.0949,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9707 9.14062L53.5007 26.5006",
    stroke: "#FFA940",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.9 21.7402L134.65 33.8602",
    stroke: "#FFA940",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.731 104.96C143.201 107.43 137.641 106.09 134.161 101.69C127.021 92.6405 114.841 77.6205 106.521 69.5805C93.5211 57.0205 96.731 35.8805 115.691 32.4605C131.351 29.6405 147.051 64.7505 153.931 87.5705C156.021 94.4905 153.401 101.87 147.731 104.96Z",
    fill: "#FFE8CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2801 113.79C54.2801 115.88 75.7301 106.2 78.5901 101.75C84.4801 92.6105 77.8701 85.4905 84.8201 77.2505C95.6701 64.3905 92.1901 44.2805 75.6501 42.1805C61.9901 40.4505 49.5401 75.1405 44.3301 97.4705C42.7501 104.26 42.5201 113.35 50.2801 113.79Z",
    fill: "#FFE8CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.87 79.7004L82.4599 110.78C82.4599 110.78 88.9 114.64 113.98 112.34C114.31 112.31 114.61 112.16 114.93 112.06C131.79 106.96 132.7 106.92 132.7 106.92L132.72 50.0604C125.87 33.2604 106.46 25.4704 89.89 32.8804L83.7099 35.6504C66.8799 43.1504 59.35 62.8804 66.87 79.7004Z",
    fill: "#FFE8CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5199 94.9904L55.5998 116.3C45.4598 123.07 42.1099 133.96 47.2699 143.42L54.4598 156.62H176.17L179.69 136.07C181.11 127.83 176.33 119.69 167.29 114.96L125.97 93.3304L87.5199 94.9904Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.463 58.1121L79.1914 65.7272L89.0138 120.252L131.285 112.637L121.463 58.1121Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8196 44.6005C105.355 42.2445 108.132 33.3391 105.021 24.7096C101.91 16.0801 94.0904 10.9945 87.5547 13.3505C81.0189 15.7064 78.2424 24.6119 81.3532 33.2414C84.4639 41.8708 92.2838 46.9565 98.8196 44.6005Z",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8906 28.1105C97.8906 28.1105 102.581 32.2105 99.8406 33.5105",
    stroke: "#D9480F",
    strokeWidth: 0.5475,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7508 8.77047C82.7508 8.77047 70.1108 7.85047 70.9008 21.9205C71.7208 36.5105 84.3908 38.5505 84.3908 38.5505L81.3207 30.0305C81.3207 30.0305 84.9508 26.7405 88.0508 17.5205C88.0508 17.5205 95.3707 22.9805 103.071 13.1705C103.071 13.1705 99.8908 11.7705 101.031 7.51047C102.161 3.25047 86.4008 -3.37953 82.7508 8.77047Z",
    fill: "#D9480F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4022 33.9629C85.8991 32.7224 86.0098 30.3861 84.6495 28.7446C83.2892 27.1031 80.973 26.778 79.476 28.0185C77.9791 29.259 77.8684 31.5953 79.2287 33.2368C80.589 34.8783 82.9053 35.2034 84.4022 33.9629Z",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6504 28.4705C90.9204 29.5505 92.8304 29.4005 93.9104 28.1305",
    stroke: "#D9480F",
    strokeWidth: 0.5475,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1602 24.9705C100.83 24.9305 102.15 23.5505 102.11 21.8805",
    stroke: "#D9480F",
    strokeWidth: 0.5475,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.251 90.3804C133.051 86.3904 124.131 66.2304 123.601 65.7504C121.951 64.2404 115.561 58.9404 115.951 57.9504C117.131 54.9704 123.681 52.8004 123.681 52.8004C123.681 52.8004 154.581 84.7804 146.701 92.2304C143.221 95.5204 137.541 94.5204 135.251 90.3804Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.001 126.13C147.521 125.99 147.091 125.66 146.831 125.18L144.391 120.67C143.871 119.71 144.231 118.51 145.191 117.99C146.151 117.47 147.351 117.83 147.871 118.79L150.311 123.3C150.831 124.26 150.471 125.46 149.511 125.98C149.031 126.24 148.491 126.28 148.001 126.13Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.242 65.2086L88.0293 70.111L91.3714 88.6631L118.584 83.7608L115.242 65.2086Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3935 40.5257L69.4023 42.8885L81.0477 72.4163L87.0389 70.0534L75.3935 40.5257Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.526 32.1751L114.287 32.2743L114.574 50.3225L120.813 50.2233L120.526 32.1751Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.7 121.08H92.7598V133.96H132.7V121.08Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.599 112.71C154.599 108.8 135.849 105.62 112.729 105.62C89.6094 105.62 70.8594 108.79 70.8594 112.71C70.8594 114.14 70.8594 119.01 70.8594 120.44C70.8594 124.35 89.6094 127.53 112.729 127.53C135.849 127.53 154.599 124.36 154.599 120.44C154.599 119.01 154.599 114.13 154.599 112.71Z",
    fill: "#FFE8CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.729 118.51C135.854 118.51 154.599 115.336 154.599 111.42C154.599 107.505 135.854 104.33 112.729 104.33C89.6052 104.33 70.8594 107.505 70.8594 111.42C70.8594 115.336 89.6052 118.51 112.729 118.51Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.87 135.32C146.87 132.13 131.59 129.54 112.73 129.54C93.8699 129.54 78.5898 132.13 78.5898 135.32C78.5898 136.48 78.5898 140.46 78.5898 141.62C78.5898 144.81 93.8799 147.4 112.73 147.4C131.58 147.4 146.87 144.81 146.87 141.62C146.87 140.46 146.87 136.48 146.87 135.32Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.73 140.39C131.585 140.39 146.87 137.803 146.87 134.61C146.87 131.418 131.585 128.83 112.73 128.83C93.8749 128.83 78.5898 131.418 78.5898 134.61C78.5898 137.803 93.8749 140.39 112.73 140.39Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.74 60.4304H100.17V62.9404C100.17 62.9404 105.64 64.3904 105.64 72.1204C105.64 78.5604 101.78 77.2704 99.3096 82.2304C92.4996 95.9304 105.64 108.19 105.64 108.19L106.09 112.49C106.25 114 107.44 115.19 108.95 115.34L111.64 115.61C113.64 115.81 115.66 115.77 117.65 115.49L121.47 114.94C122.73 114.76 123.67 113.68 123.67 112.4V106.89C123.67 106.89 133.98 97.8704 130.11 84.9904C128.58 79.8904 124.96 79.8404 123.53 74.2304C122.73 71.0904 124.61 63.0904 127.53 63.0904L127.74 60.4304Z",
    fill: "#E8590C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.36 59.5205C97.9204 64.3905 95.3405 59.2405 97.9205 59.2405C100.5 59.2405 104.36 55.3805 104.36 55.3805L105.65 51.5205L113.38 47.6605H118.53L123.68 52.8105L121.1 55.3905L119.811 60.5405L105.61 60.4405L104.36 59.5205Z",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.221 54.0905L109.511 59.2405",
    stroke: "#FFC078",
    strokeWidth: 1.0949,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.73 53.4404V59.8904",
    stroke: "#FFC078",
    strokeWidth: 1.0949,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.6 53.4404V59.8904",
    stroke: "#FFC078",
    strokeWidth: 1.0949,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8501 92.8904C70.3101 91.3604 88.3201 88.6504 93.2101 82.8904C101.03 73.6704 106.5 74.2905 106.5 74.2905C107.29 75.7605 104.4 77.7205 102.52 78.8005C101.75 79.2405 101.65 80.3105 102.35 80.8605C104.69 82.7105 110.05 85.3805 117.78 79.8305C118.71 79.1605 119.97 80.0805 119.59 81.1605C118.61 83.9405 115.26 87.8604 104.46 89.2505C98.3401 90.0405 98.4501 90.1805 98.4501 90.1805C98.4501 90.1805 61.0801 113.02 56.9901 102.84C55.1801 98.3504 59.1901 94.4804 64.8501 92.8904Z",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5293 36.8305C96.5293 36.8305 98.6193 38.7705 100.549 36.7805",
    stroke: "#D9480F",
    strokeWidth: 0.5475,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtRightImage);
export default __webpack_public_path__ + "static/media/artRightImage.11c3fc9690ed2b825bc75b0264910c03.svg";
export { ForwardRef as ReactComponent };